var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"copy"},[_c('button',{staticClass:"copy-button",attrs:{"type":"button"},on:{"click":_vm.copyLink}},[_c('Icon',{attrs:{"iconName":_vm.iconName,"iconColor":"#788694"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }